module.exports = __webpack_public_path__ + "img/wortels-met-tijm.70ffc536.jpeg";